import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'

import FacebookCarouselItemFooter from './FacebookCarouselItemFooter'
import FacebookCarouselItemThumbnail from './FacebookCarouselItemThumbnail'

import { CAROUSEL_ITEMS } from '../../../../../../forms/Facebook/AdForms/fields'
import {
  FILE_ID,
  FILE_NAME,
  FILE_URL,
  IMAGE_HASH,
  MEDIA_TYPE,
  VIDEO_PICTURE
} from '../../../../../../forms/ReusableFormFields/AdFileUpload/fields'

import useStyles from './styles'

function FacebookCarouselItem({
  viewAdOnFacebook,
  formikValues,
  selectedCarouselItemIndex,
  lastItemIndex,
  isActive,
  handleItemClick,
  index,
  isSoundMuted,
  carouselContainerWidth
}) {
  const carouselItem = getIn(formikValues, `${CAROUSEL_ITEMS}[${index}]`)

  const mediaFile = {
    [MEDIA_TYPE]: getIn(carouselItem, MEDIA_TYPE),
    [FILE_NAME]: getIn(carouselItem, FILE_NAME),
    [FILE_URL]: getIn(carouselItem, FILE_URL),
    [IMAGE_HASH]: getIn(carouselItem, IMAGE_HASH),
    [VIDEO_PICTURE]: getIn(carouselItem, VIDEO_PICTURE),
    [FILE_ID]: getIn(carouselItem, FILE_ID)
  }

  const classes = useStyles({ selectedCarouselItemIndex, lastItemIndex, carouselWidth: carouselContainerWidth })

  const selectCarouselItem = () => {
    if (!handleItemClick) return
    handleItemClick && handleItemClick({ index, isFormOpened: false })
  }

  return (
    <div className={classes.carouselItem} onClick={selectCarouselItem}>
      <div className={classes.thumbnail}>
        <FacebookCarouselItemThumbnail
          viewAdOnFacebook={viewAdOnFacebook}
          mediaFile={mediaFile}
          isActive={isActive}
          isSoundMuted={isSoundMuted}
        />
      </div>
      <FacebookCarouselItemFooter formikValues={formikValues} isActive={isActive} index={index} />
    </div>
  )
}

FacebookCarouselItem.propTypes = {
  viewAdOnFacebook: PropTypes.string,
  formikValues: PropTypes.object,
  selectedCarouselItemIndex: PropTypes.number,
  lastItemIndex: PropTypes.number,
  isActive: PropTypes.bool,
  handleItemClick: PropTypes.func,
  index: PropTypes.number,
  isSoundMuted: PropTypes.bool,
  carouselContainerWidth: PropTypes.number
}

export default FacebookCarouselItem
